export const runWorker = async <TRequest, TResponse extends { type: string }>(
  worker: Worker,
  request: TRequest,
  transferables?: Transferable[]
): Promise<Exclude<TResponse, { type: 'error' }>> => {
  const { promise, resolve, reject } = Promise.withResolvers<Exclude<TResponse, { type: 'error' }>>();

  worker.onmessage = (e: MessageEvent) => {
    const response = e.data as TResponse;
    if ('type' in response && response.type === 'error') {
      reject(new Error('error' in response ? String(response.error) : 'Unknown worker error'));
    } else {
      resolve(response as Exclude<TResponse, { type: 'error' }>);
    }
    worker.terminate();
  };

  worker.onerror = (error) => {
    reject(error);
    worker.terminate();
  };

  if (transferables) {
    worker.postMessage(request, transferables);
  } else {
    worker.postMessage(request);
  }

  return promise;
};
